import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/profile/:nickname',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/ProfileView.vue'),
  },
  {
    path: '/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '../views/SearchView.vue'),
  },
  {
    path: '/account',
    name: 'edit-profile',
    component: () => import(/* webpackChunkName: "edit-profile" */ '../views/EditProfileView.vue'),
  },
  {
    path: '/catalogo',
    name: 'manage-catalog',
    component: () => import(/* webpackChunkName: "manage-catalog" */ '../views/ManageCatalogView.vue'),
  },
  {
    path: '/authors/:id',
    name: 'author-books',
    component: () => import(/* webpackChunkName: "author-books" */ '../views/AuthorBooksView.vue'),
    props: (route) => ({ id: route.params.id, name: route.query.name || '' }),
  },
  {
    path: '/books/:id',
    name: 'book-quotes',
    component: () => import(/* webpackChunkName: "author-books" */ '../views/BookQuotesView.vue'),
    props: (route) => ({ id: route.params.id, name: route.query.name || '' }),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router